import crud_actions from './crud_actions'
import log from 'lib/log'
export const INITIALISE_ATTACHMENTS = 'initialise_attachments'
export const UPLOAD_ATTACHMENT_REQUEST = 'upload_attachment_request'
export const UPLOAD_ATTACHMENT_SUCCESS = 'upload_attachment_success'
export const UPLOAD_ATTACHMENT_FAILURE = 'upload_attachment_failure'
export const UPLOAD_ATTACHMENT_PROGRESS = 'upload_attachment_progress'
export const UPDATE_ATTACHMENT = 'update_attachment'
export const REMOVE_ATTACHMENT = 'remove_attachment'

export const initialiseAttachments = opts => {
  return {
    type: INITIALISE_ATTACHMENTS,
    payload: {
      opts
    }
  }
}

const uploadRequest = opts => ({
  type: UPLOAD_ATTACHMENT_REQUEST,
  payload: {
    opts
  }
})

const uploadSuccess = (opts, result) => ({
  type: UPLOAD_ATTACHMENT_SUCCESS,
  payload: {
    opts,
    result
  }
})

const uploadFailure = (opts, error) => ({
  type: UPLOAD_ATTACHMENT_FAILURE,
  payload: {
    opts,
    error
  }
})

const uploadProgress = (opts, progress) => ({
  type: UPLOAD_ATTACHMENT_PROGRESS,
  payload: {
    opts,
    progress
  }
})

export const updateAttachment = opts => ({
  type: UPDATE_ATTACHMENT,
  payload: {
    opts
  }
})

export const removeAttachment = opts => ({
  type: REMOVE_ATTACHMENT,
  payload: {
    opts
  }
})

let id = 0

export const uploadAttachment = opts => {
  return async (dispatch, getState, { api }) => {
    const _id = id++
    const optsWithId = { _upload_id: _id, ...opts }
    dispatch(uploadRequest(optsWithId))
    try {
      const onProgress = progress => {
        dispatch(uploadProgress(optsWithId, progress))
      }
      const data = await api.upload({ ...optsWithId, onProgress })
      if (data) {
        dispatch(uploadSuccess(optsWithId, data))
        return data
      } else {
        dispatch(uploadFailure(optsWithId, new Error('no data')))
        return undefined
      }
    } catch (err) {
      log.error(err)
      dispatch(uploadFailure(optsWithId, err))
      throw err
    }
  }
}
